import { Outlet } from "react-router-dom";
import ScrollToTopComponent from "src/components/scroll-to-top";

function PrivateLayout() {
  return (
    <div className="private-layout">
      <Outlet />
      <ScrollToTopComponent />
    </div>
  );
}

export default PrivateLayout;
